<template>
  <b-dropdown
    toggle-class="text-decoration-none"
    variant="light select-page"
    ref="dropdown"
    id="btn-select-page"
    menu-class="w-100"
    :disabled="!pageId"
  >
    <template #button-content>
      <div class="d-flex justify-content-between align-items-center">
        <span class="fs-sa-14 -mb-0 page-title">{{ getSelectedText }}</span>
        <i class="far fa-angle-down"></i>
      </div>
    </template>
    <perfect-scrollbar ref="scrollbar">
      <b-dropdown-item-button
        v-for="(section, index) in getData"
        :key="`section_${index}_${section.value}`"
        @click="setData(section.value)"
      >
        <p class="fs-sa-14 mb-0">
          {{ section.text }}
          <span v-if="!section.isEnable" class="ml-3"><i class="far fa-eye-slash text-hint"></i></span>
        </p>
      </b-dropdown-item-button>
    </perfect-scrollbar>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import siteService from "@services/siteService.js";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";

export default {
  data() {
    return {
      showIcon: true,
      getData: [],
    };
  },
  components: {
    PerfectScrollbar,
  },
  async mounted() {
    await this.getSite();
    this.$refs.dropdown.$el.addEventListener('keydown', this.onDocKeyDown);
  },
  watch: {
    pageId() {
      this.getSite();
    },
  },
  methods: {
    setData(id) {
      this.$emit("input", id);
    },
    async getSite() {
      let data = [];
      if (this.pageId) {
        const metaDataID =
          this.siteComponents[this.pageId].properties.metaDataID;

        await siteService
          .getSitePage({ lang: this.siteActiveLanguage, id: metaDataID })
          .then((response) => {
            const CONTENT_CONTAINER =
              response.props.components.CONTENT_CONTAINER;
            const section = response.assets.components;
            CONTENT_CONTAINER.componentsID.map((sec_id) => {
              data.push({
                value: section[sec_id].id,
                text: section[sec_id].properties.name,
                isEnable: section[sec_id].properties.isEnable,
              });
            });
            this.getData = data;
          })
          .catch(() => {
            this.getData = [];
          });
      }
    },
    // Navigation
    navigate(text) {
      // reset hover
      const $elemHovered = this.$refs.dropdown.$el.querySelector('.dropdown-item.hover');
      if ($elemHovered) {
        $elemHovered.classList.remove('hover'); 
      }

      // find
      const $label = this.$refs.dropdown.$el.querySelector(`.dropdown-item .dropdown-item-label[title^="${text}"]`);
      if (!$label) return;

      const $elem = $label.closest('.dropdown-item');
      const $scrollbar = this.$refs.scrollbar.$el;

      $scrollbar.scrollTop = 0; // reset
      $scrollbar.scrollTop = $elem.getBoundingClientRect().top - $scrollbar.getBoundingClientRect().top; // goto
      $elem.classList.add('hover'); // hover
    },
    onDocKeyDown(e) {
      this.navigate(e.key.toUpperCase());
    },
  },
  computed: {
    ...mapGetters({
      siteActiveLanguage: "design/metadata/siteActiveLanguage",
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
    }),
    getSelectedText() {
      if (this.pageId != null && this.getData.length == 0) {
        return this.$t(
            "engine.modal.addlink.setting.selectSection.lblNoResult",
            this.languageEngine
          );
      } else {
        const result = this.getData.filter((item) => item.value === this.value);

        if (result.length > 0) {
          result[0].text;
        } else {
          this.$emit("input", null);
          return this.$t(
            "engine.modal.addlink.setting.selectSection.lblChooseSection",
            this.languageEngine
          );
        }
        return result[0] && result[0].text;
      }
    },
  },
  props: {
    value: {
      required: true,
    },
    pageId: {
      required: true,
    },
  },
};
</script>

<style scope>
#btn-select-page .dropdown-menu {
  min-width: 15rem;
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.176);
}
#btn-select-page .dropdown-menu .ps {
  height: auto;
  max-height: 300px;
}
</style>
